import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, countries, gamesCasino, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableProductsBanksView.
 * @extends JetView
 */
export default class tableProductsBanksView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date format function
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        return {
            rows: [
                {
                    id: 'preloader', // ID for preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('categoriesProductsEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 55, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'Product', // Column ID
                                    header: _('Productos'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'BankId', // Column ID
                                    header: _('Banco'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sort type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    $$('editwinProductBank').show(); // Show edit window on click
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // API URL for fetching data
                            url:
                                devConfig.geturlApi() +
                                'PartnersBanks/GetPartnersBanksProducts?Partner=' +
                                id_partner +
                                '&',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // Store the URL for data fetching
        var filter = ''; // Initialize filter variable
        var optionsCategorias = []; // Initialize options for categories
        var popup = webix.ui({
            // Create edit window UI
            view: 'window',
            id: 'editwinProductBank', // ID for the edit window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 680 : 300, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Productos a Bancos') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for editing
                    id: 'editform', // ID for the form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 680 : 380, // Height based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelWidth: 90,
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Product
                            label: _('Producto'),
                            name: 'Product',
                            readonly: true, // Read-only field
                            labelWidth: 90,
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'text', // Text input for Bank ID
                            label: _('Banco'),
                            name: 'BankId',
                            readonly: true, // Read-only field
                            labelWidth: 90,
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'),
                            name: 'IsActivate',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelWidth: 90,
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('editform').getValues(); // Get form values
                                        values.Partner = id_partner; // Add partner ID to values
                                        webix
                                            .ajax() // AJAX request to save changes
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnersBanks/UpdatePartnersBanksProducts',
                                                '{"Id":' +
                                                    values.Id +
                                                    ',"IsActivate":"' +
                                                    values.IsActivate +
                                                    '","BankId":"' +
                                                    values.BankId +
                                                    '","Partner":"' +
                                                    values.Partner +
                                                    '","Product":"' +
                                                    values.Product +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Producto a Banco Editada', // Success message
                                                        );
                                                        grid.clearAll(); // Clear grid data
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide window after saving
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var vthis = this; // Preserve context for event handlers
        this.on(this.app, 'productsBanks:filter', (filterData) => {
            // Event handler for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload grid data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.refreshColumns(); // Refresh columns after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload grid data with sorting
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item clicks
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data for selected player
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to fetch initial data
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'PartnersBanks/GetPartnersBanksProducts', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    for (var i = 0; i < resp.data.length; i++) {
                        resp.data[i].id = resp.data[i].Id; // Map ID
                        resp.data[i].value = resp.data[i].Description; // Map description
                    }
                    optionsCategorias = resp.data; // Store options for categories
                    var popupAdd = webix.ui({
                        // Create add product window UI
                        view: 'window',
                        id: 'AddCategoriesProduct', // ID for the add window
                        width: screen.width < 500 ? 350 : 450, // Width based on screen size
                        height: screen.width < 500 ? 600 : 310, // Height based on screen size
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                        head: {
                            view: 'toolbar', // Toolbar for the window header
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Agregar Producto a Banco'), // Label for the window
                                },
                                {
                                    view: 'icon', // Close icon
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide window on click
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the window
                        modal: true, // Modal window
                        body: {
                            view: 'scrollview', // Scrollable body
                            scroll: 'y',
                            body: {
                                view: 'form', // Form for adding product
                                id: 'addformPB', // ID for the form
                                width: screen.width < 500 ? 350 : 450, // Width based on screen size
                                height: screen.width < 500 ? 600 : 250, // Height based on screen size
                                elements: [
                                    {
                                        view: 'richselect', // Rich select for country selection
                                        name: 'CountrySelect',
                                        id: 'CountrySelect',
                                        minWidth: 200,
                                        localId: 'regions:combo',
                                        label: "<span class='icon-language'></span>" + _('País'), // Localized label
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                        on: {
                                            onChange: function (data, obj) {
                                                // Change event handler
                                                var currentValue = this.getValue(); // Get current value
                                                if (currentValue.length > 0) {
                                                    $$('button').enable(); // Enable button if value is selected
                                                } else {
                                                    $$('button').disable(); // Disable button if no value
                                                }
                                            },
                                        },
                                        options: {
                                            body: {
                                                template: function (obj) {
                                                    // Template for displaying country options
                                                    return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                                },
                                                data: countries, // Country data
                                            },
                                        },
                                        hidden: !devConfig.getPermAction(
                                            // Hide if permission denied
                                            'filterByCountry',
                                            'Add',
                                        ),
                                        css: 'prm-filterByCountry', // CSS class for styling
                                    },
                                    {
                                        view: 'combo', // Combo box for product selection
                                        name: 'Product',
                                        localId: 'product:combo',
                                        label: _('Productos'), // Localized label
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                        options: {
                                            body: {
                                                dataFeed: function (text) {
                                                    // Data feed function for product options
                                                    var vthis = this;
                                                    if (text.length > 2) {
                                                        // Fetch data if input length is greater than 2
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'es/Select/ProductsBanksSelect',
                                                                '{"Filter":"' + text + '"}',
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Error message on failure
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var resp = JSON.parse(text); // Parse response
                                                                        if (!resp.HasError) {
                                                                            vthis.parse(
                                                                                resp.Data, // Parse data into combo
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                    }
                                                },
                                            },
                                        },
                                    },
                                    {
                                        view: 'combo', // Combo box for bank selection
                                        name: 'BankId',
                                        localId: 'Bank:combo',
                                        label: _('Banco'), // Localized label
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                        options: {
                                            body: {
                                                dataFeed: function (text) {
                                                    // Data feed function for bank options
                                                    var vthis = this;
                                                    if (text.length > 2) {
                                                        // Fetch data if input length is greater than 2
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'es/Select/BanksSelect',
                                                                '{"Filter":"' + text + '"}',
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Error message on failure
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var resp = JSON.parse(text); // Parse response
                                                                        if (!resp.HasError) {
                                                                            vthis.parse(
                                                                                resp.Data, // Parse data into combo
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                    }
                                                },
                                            },
                                        },
                                    },
                                    {
                                        view: 'combo', // Combo box for activation status
                                        label: _('Estado'),
                                        name: 'IsActivate',
                                        options: [
                                            {
                                                id: 'A',
                                                value: _('Activado'), // Localized value
                                            },
                                            {
                                                id: 'I',
                                                value: _('Inactivado'), // Localized value
                                            },
                                        ],
                                        labelPosition: screen.width < 500 ? 'top' : 'left',
                                        placeholder: _(
                                            'Click para seleccionar ', // Placeholder text
                                        ),
                                    },
                                    {
                                        cols: [
                                            // Button layout
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'),
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide window on click
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Reset form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form',
                                                value: _('Guardar'),
                                                click: function ($e) {
                                                    var values = $$('addformPB').getValues(); // Get form values
                                                    values.Partner = id_partner; // Add partner ID to values
                                                    webix
                                                        .ajax() // AJAX request to save new product
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                                'PartnersBanks/SavePartnersBanksProducts',
                                                            '{"BankId":"' +
                                                                values.BankId +
                                                                '", "Product":"' +
                                                                values.Product +
                                                                '", "IsActivate":"' +
                                                                values.IsActivate +
                                                                '", "CountrySelect":"' +
                                                                values.CountrySelect +
                                                                '", "Partner":"' +
                                                                id_partner +
                                                                '"}',
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error! ', // Error message on failure
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Categoría Producto Agregada', // Success message
                                                                    );
                                                                    grid.clearAll(); // Clear grid data
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    $$('addformPB').setValues(
                                                        $$('addformPB').getCleanValues(), // Reset form values
                                                    );
                                                    this.getTopParentView().hide(); // Hide window after saving
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    vthis.on(vthis.app, 'addProductBank:button', (filter) => {
                        popupAdd.show(); // Show add product window
                    });
                },
            });
    }
}

// FILE DOCUMENTED
